import { ConstraintManualObligationBase } from './base/constraint-manual-obligation-base';

export class ConstraintManualObligation extends ConstraintManualObligationBase { }